import { AnimatePresence, motion } from "framer-motion";
import classes from "./VideoControl.module.scss";
import PlayIcon from "../../icons/Play";
import { NAME_SOUND_HOVER, useGameSounds } from "@educaplay/core";


export function VideoControl(props) {

    const { show, onClick } = props;
    const gameSound = useGameSounds();

    return (
        <AnimatePresence>
            {!show && (
                <motion.div className={classes.playicon}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <button className={classes.videocontrols} onClick={onClick} onMouseEnter={()=> gameSound.play(NAME_SOUND_HOVER)}>
                            <PlayIcon/>   
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    )
}